import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'polishIban' })
export class PolishIbanPipe implements PipeTransform {

    transform(value: string | null | undefined): string {
        if (!value) return '';

        // remove non-alphanumeric chars and uppercase
        const iban = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

        // basic sanity: require at least a country code and some chars
        if (iban.length < 4) return value;

        // take first 2 chars, then format the rest in groups of 4
        const head = iban.slice(0, 2);
        const tail = iban.slice(2);
        const groupedTail = tail.replace(/(.{4})/g, '$1 ').trim();

        return (head + (groupedTail ? ' ' + groupedTail : '')).trim();
    }
}